<template>
  <div class="sellCenter container">
    <!-- 过滤条件start -->
    <div ref="headerBtn" class="headerBtn">
      <!-- 顶部按钮start -->
      <div>
        <el-button @click="toAddGoods" size="mini" type="info"
          >创建商品</el-button
        >
        <el-button @click="() => addOrRemoveFromSell(1)" size="mini" type="info"
          >上架</el-button
        >
        <el-button @click="() => addOrRemoveFromSell(0)" size="mini" type="info"
          >下架</el-button
        >
        <el-button size="mini" @click="resetPage" type="info">刷新</el-button>
      </div>
      <!-- 顶部按钮end -->
    </div>
    <!-- 过滤条件end -->
    <div>
      <el-table
        :data="list"
        border
        highlight-current-row
        v-loading="loading"
        ref="table"
        size="mini"
        row-key="id"
        :height="tabHeight"
        @selection-change="handleSelectionChange"
        :style="{ 'background-color': 'transparent' }"
        :header-cell-style="{ 'background-color': '#f8f8f8' }"
        @row-click="onRowClick"
       :row-class-name="tableRowClassName"
      >
        <el-table-column type="selection" align="center" width="55">
        </el-table-column>

        <el-table-column align="center" label="序号" type="index" width="50">
        </el-table-column>

        <el-table-column
          width="150"
          show-overflow-tooltip
          align="center"
          label="操作"
        >
          <div slot-scope="scope">
            <!-- <el-button class="_mini" type="info" size="mini">设置</el-button> -->
            <!-- <el-button class="_mini" type="info" size="mini"
              >查看库存</el-button
            > -->
            <el-button
              class="_mini"
              @click="() => addToStore(scope.row)"
              type="info"
              size="mini"
              >入库</el-button
            >
            <el-button
              @click="() => editGoods(scope.row,scope.$index)"
              class="_mini"
              type="info"
              size="mini"
              >编辑</el-button
            >

            <el-button
              class="_mini"
              @click="() => deleteGoods(scope.row)"
              type="danger"
              size="mini"
              >删除</el-button
            >
            <!--
            <el-button class="_mini" type="info" size="mini"
              >设置秒杀</el-button
            > -->
          </div>
        </el-table-column>

        <el-table-column
          show-overflow-tooltip
          align="center"
          prop="name"
          label="名称"
          width="150"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          prop="status"
          label="状态"
          width="150"
        >
          <template slot-scope="scope">
            <div :class="setClass(scope.row)">
              {{ statusFormatter(scope.row) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          prop="breed"
          label="品种"
          width="150"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          width="100"
          prop="goodsType"
          label="类型"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="coverPlan"
          align="center"
          label="封面"
          width="100"
        >
          <template slot-scope="scope">
            <el-image
              style="width: 50px; height: 50px"
              :src="getImageUrl(scope.row.coverPlan)"
              fit="cover"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          width="150"
          prop="stockCount"
          label="库存"
        >
          <template slot-scope="scope">
            <div :class="scope.row.stockCount == 0 ? 'red' : ''">
              {{ scope.row.stockCount || 0 }}{{ scope.row.buyUnit }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          width="150"
          prop="stockCount"
          label="单价"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.price || 0 }}元/{{ scope.row.unit }}</div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          width="90"
          prop="birthPlace"
          label="产地"
        >
          <template slot-scope="scope">
            <div>{{ $getAreaInfo(scope.row.birthPlace)[0] }}</div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页start -->
      <div class="pagination">
        <el-pagination
          background
          layout="total, prev, pager, next,sizes, jumper"
          :total="total"
          :current-page="vueXPageIndex||pageIndex"
          @current-change="handleCurrentChange"
          :page-size="cureentPageSize||pageSize"
          @size-change="handleSizeChange"
          :pageSizes="[15, 50, 100, 1000]"
        >
        </el-pagination>
      </div>
      <!-- 分页end -->
    </div>

    <div>
      <el-dialog title="选择入库白条" :visible.sync="whiteBarListShow">
        <div class="btnBox">
          <el-button size="mini" @click="addWhiteBarToStore" type="info"
            >入库</el-button
          >
        </div>
        <el-table
          :border="true"
          :stripe="true"
          :max-height="500"
          size="mini"
          :data="whiteBarList"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column type="index" width="50"> </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="image"
            align="center"
            label="白条封面"
            width="100"
          >
            <template slot-scope="scope">
              <el-image
                style="width: 50px; height: 50px"
                :src="getImageUrl(scope.row.image)"
                fit="cover"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="center"
            prop="breed"
            label="白条品种"
            width="100"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="center"
            prop="grade"
            :formatter="geadeFormatter"
            label="白条等级"
            width="90"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="center"
            width="90"
            prop="birthPlace"
            label="白条产地"
          >
            <div slot-scope="scope">
              {{ $getAreaInfo(scope.row.birthPlace)[0] }}
            </div>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="center"
            width="120"
            prop="weight"
            label="均重(kg)"
          >
          </el-table-column>
        </el-table>
        <el-pagination background layout="total" :total="whiteBarCount">
        </el-pagination>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getStoreGoodsUrl,
  getImageUrl,
  getAreaByAreaId,
  goodUnsellsUrl,
  deleteGoodsUrl,
  addStockGoodsUrl,
  getMineWhiteBarListUrl,
  storeSort,
} from "@/api/api";
// import Sortable from 'sortablejs'
import Sortable, { AutoScroll } from "sortablejs/modular/sortable.core.esm.js";
import { mapMutations, mapState } from "vuex";
export default {
  name: "whitebar",
  data() {
    return {
      tabHeight: "300px",
      formInline: {
        user: "",
        region: "",
      },
      list: null,
      selectedList: null,
      loading: false,
      total: 0,
      pageIndex: 1,
      whiteBarListShow: false,
      whiteBarList: null,
      whiteBarCount: 0,
      selectedList: null,
      currentRow: null,
      pageSize: 50,
    };
  },
  mounted() {
    this.getImageUrl = getImageUrl;
    this.pageIndex = this.vueXPageIndex ||this.pageIndex;
    this.pageSize = this.cureentPageSize||this.pageSize
    this.setTableHeight();
    window.addEventListener("resize", this.setTableHeight);
    Sortable.mount(new AutoScroll());
    this.initData();
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
    this.rowDrop();
  },
  computed: {
    ...mapState(["userInfo","currentEditIndex","cureentPageSize","vueXPageIndex"]),
  },
  methods: {
    ...mapMutations(["savecurrentEditRow","savecurrentIndex","saveVueXPageIndex","saveCureentPageSize"]),
        tableRowClassName({ row, rowIndex }) {
      if (rowIndex === this.currentEditIndex) {
        return " current-row";
      }
      row.row_index = rowIndex;

    },
    onRowClick(row, event, column) {
      this.savecurrentIndex(null);
    },
    handleSizeChange(e) {
      console.log(e);

      this.savecurrentIndex(null);
       this.saveCureentPageSize(null)
      this.saveVueXPageIndex('');
      this.pageSize = e;
      this.$nextTick(() => {
        this.initData();
      });
    },
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
        
          const currRow = _this.list.splice(oldIndex, 1)[0];
          _this.list.splice(newIndex, 0, currRow);
          // console.log('newIndex',newIndex)
          // console.log('oldIndex',oldIndex)
          _this.startSort(newIndex - oldIndex, currRow);
        },
      });
    },
    startSort(offset, currRow) {
      console.log("offset", offset);
      let data = {
        access_token: this.userInfo.access_token,
        storeId: this.userInfo.storeId,
        gid: currRow.id,
        offset,
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({ method: "post", data: param, url: storeSort })
        .then((res) => {
          if (res.data.resultCode == 1) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
          } else {
            this.initData();
            this.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.initData();
          console.log("this.$refs.table", this.$refs.table);
          this.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    editGoods(row,index) {
      this.savecurrentEditRow(row);
      this.savecurrentIndex(index)
      this.saveVueXPageIndex(this.pageIndex)
      this.saveCureentPageSize(this.pageSize)
      this.$router.push({ name: "commodityAdd", query: { id: row.id } });
    },
    addWhiteBarToStore() {
      console.log(this.selectedList);
      console.log(this.currentRow);
      if (!this.selectedList.length) {
        this.$alert("请选择入库白条", "提示");
        return;
      }

      let sids = this.selectedList.map((item) => item.id).join(",");
      console.log("sids", sids);
      let data = {
        access_token: this.userInfo.access_token,
        storeId: this.userInfo.storeId,
        gid: this.currentRow.id,
        sids,
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({ method: "post", data: param, url: addStockGoodsUrl })
        .then((res) => {
          if (res.data.resultCode == 1) {
            this.whiteBarListShow = false;
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.initData();
          } else {
            this.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },

    handleSelectionChange(e) {
      this.selectedList = e;
    },
    geadeFormatter(row, column) {
      switch (row.grade) {
        case 1:
          return "一级";
        case 2:
          return "二级";
        case 3:
          return "三级";
        case 4:
          return "四级";
        case 5:
          return "五级";
      }
    },
    handleCurrentChange(e) {
      console.log(e);
      this.pageIndex = e;
            // alert(this._currentRowIndex)
      this.savecurrentIndex(null);
      this.saveVueXPageIndex('');
      this.saveCureentPageSize('')
      setTimeout(() => {
        this.initData();
      });
    },
    checkWhiteBarAddStore(row) {
      console.log("this.userInfo", this.userInfo);
      this.loading = true;
      let breed = row.breed;
      if (breed.indexOf(",") > -1) {
        breed = breed.split(",")[2];
      }
      let data = {
        access_token: this.userInfo.access_token,
        storeId: this.userInfo.storeId,
        breed: breed,
        grade: row.grade,
        birthPlace: row.birthPlace,
        pageSize: 999,
        pageIndex: 0,
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({ method: "post", data: param, url: getMineWhiteBarListUrl })
        .then((res) => {
          this.loading = false;
          if (res.data.resultCode == 1) {
            console.log(res.data);
            if (res.data.count == 0) {
              this.$confirm(
                "暂无满足对应新的白条库存,是否添加白条入库",
                "提示",
                {
                  confirmButtonText: "添加白条",
                  cancelButtonText: "取消",
                  // type: "warning"
                }
              )
                .then(() => {
                  this.$router.push("addWhitebar");
                })
                .catch(() => {});
            } else {
              this.whiteBarCount = res.data.count;
              this.whiteBarList = res.data.data;
              this.currentRow = row;
              this.$nextTick(() => {
                this.whiteBarListShow = true;
              });
            }
          } else {
            this.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    addToStore(row) {
      let { goodsType, types, breed, stockCount } = row;
      if (goodsType.indexOf("白条") > -1 || breed.indexOf("白条") > -1) {
        this.checkWhiteBarAddStore(row);
      } else {
        this.$prompt("请输入库数量", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(({ value }) => {
            if (isNaN(value) || value == 0 || value >= 9999999) {
              if (value < 0 && stockCount + value < 0) {
                this.$alert("库存不足，请修改削减数量");
              } else {
                this.$alert("请输入有效数值");
              }
            } else {
              this.startAddStoreCount(row, value);
            }
          })
          .catch(() => {});
      }
    },
    startAddStoreCount(row, value) {
      console.log("this.userInfo", this.userInfo);
      let data = {
        access_token: this.userInfo.access_token,
        storeId: this.userInfo.storeId,
        gid: row.id,
        count: value,
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({ method: "post", data: param, url: addStockGoodsUrl })
        .then((res) => {
          if (res.data.resultCode == 1) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.initData();
          } else {
            this.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    deleteGoods(row) {
      this.$confirm("删除选中商品?", "提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        // type: "warning"
      })
        .then(() => {
          this.ensureDeleteGoods(row);
        })
        .catch(() => {});
    },

    ensureDeleteGoods(row) {
      this.loading = true;
      let that = this;
      console.log("this.userInfo", this.userInfo);
      let data = {
        access_token: this.userInfo.access_token,
        storeId: this.userInfo.storeId,
        gid: row.id,
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({ method: "post", data: param, url: deleteGoodsUrl })
        .then(function (res) {
          that.loading = false;
          if (res.data.resultCode == 1) {
            that.$message({
              message: "操作成功",
              type: "success",
            });
            that.initData();
          } else {
            that.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch(function (error) {
          that.loading = false;
          that.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    resetPage() {
      location.reload();
    },
    handleSelectionChange(e) {
      this.selectedList = e;
    },
    addOrRemoveFromSell(status) {
      if (this.selectedList && this.selectedList.length) {
        this.loading = true;
        let that = this;
        console.log("this.userInfo", this.userInfo);
        let data = {
          access_token: this.userInfo.access_token,
          storeId: this.userInfo.storeId,
          status,
          gid: this.selectedList.map((item) => item.id).join(),
        };

        let param = new URLSearchParams();

        for (var k in data) {
          param.append(k, data[k]);
        }

        this.$axios({ method: "post", data: param, url: goodUnsellsUrl })
          .then((res) => {
            this.loading = false;
            if (res.data.resultCode == 1) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.initData();
            } else {
              this.$alert(`${res.data.resultMsg}`, "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$alert("请求异常:" + error, "提示", {
              confirmButtonText: "确定",
            });
          });
      } else {
        this.$message({
          message: "请选择操作商品",
          // type: "warning",
        });
      }
    },
    setClass(row) {
      let { status, seckillGoods } = row;
      if (status == 0) {
        return "red";
      } else if (status == "-1") {
        return "purple";
      } else if (status == 1) {
        return "green";
      }
    },
    statusFormatter(row) {
      let { status, seckillGoods } = row;
      let text1 = "";
      let text2 = "";
      if (status == 0) {
        text1 = "已下架";
      } else if (status == "-1") {
        text1 = "已强制下架";
      } else if (status == 1) {
        text1 = "上架中";
      }

      if (seckillGoods) {
        text2 = "秒杀上架中";
        text1 = "";
      }
      return text1 + text2;
    },
    initData() {
      this.loading = true;
      let that = this;
      console.log("this.userInfo", this.userInfo);
      let data = {
        access_token: this.userInfo.access_token,
        storeId: this.userInfo.storeId,
        pageIndex: this.pageIndex - 1,
        pageSize: this.pageSize,
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({ method: "post", data: param, url: getStoreGoodsUrl })
        .then(function (res) {
          that.loading = false;
          if (res.data.resultCode == 1) {
            console.log("res.data", res.data.data);
            that.list = JSON.parse(JSON.stringify(res.data.data));
            // that.$refs.table.doLayout()
            that.total = res.data.count || 0;
          } else {
            that.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          that.loading = false;
          that.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    toAddGoods() {
      this.savecurrentEditRow(null);
      this.$router.push("/sellCenter/commodityAdd");
    },
    onSubmit() {
      console.log("submit!");
    },
    setTableHeight() {
      //
      setTimeout(() => {
        let headerBtn = document.getElementsByClassName("headerBtn")[0]
          .offsetHeight;
        let paginationBtn = document.getElementsByClassName("pagination")[0]
          .offsetHeight;
        let tabHeight = window.innerHeight - headerBtn - paginationBtn - 110;
        if (tabHeight < 300) {
          tabHeight = 300;
        }
        this.tabHeight = tabHeight + "px";
      }, 100);
    },
  },
};
</script>

<style scoped lang='less'>
.headerBtn {
  width: 90%;
  margin-bottom: 10px;
}
.container {
  margin: 10px;
}
.pagination {
  margin-top: 10px;
  width: 200px;
  display: flex;
  justify-content: flex-start;
}
.btnBox {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/SellCenter/MyCommodity.vue